( function( document ) {
	'use strict';

/* -- Variables -- */

	// the interactive
	let interactive, map, layers, toggle;
	const racesLayer = [ 'white', 'black', 'hispanic' ];
	const racesData = [ 'white', 'black', 'hispanic', 'asian', 'other' ];

	// Mapbox
	const api = {
		js: 'https://api.tiles.mapbox.com/mapbox-gl-js/v0.41.0/mapbox-gl.js',
		jsSearch: 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v2.1.1/mapbox-gl-geocoder.min.js',
		css: 'https://api.tiles.mapbox.com/mapbox-gl-js/v0.41.0/mapbox-gl.css',
		cssSearch: 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v2.1.1/mapbox-gl-geocoder.css',
		accessToken: 'pk.eyJ1IjoiYnJvb2tpbmdzIiwiYSI6ImNqOTh0d3Q1MTBtcXozMm83OWFwZmVuMDkifQ.QrvtBhWEM-bTZrSYLPLAuw'
	}

	const data = {
		tileset: 'mapbox://brookings.school-segregation',
		sourceLayer: 'school-segregation',
		style: 'mapbox://styles/brookings/cj98uzelo1vkt2rqcsit019f7',
		tooltipUnderLayer: 'admin-3-4-boundaries',
		center: [-87.9, 41.9], // Illinois - Chicago
		zoom: 8
	}

	const colours = {
		na: 'rgba(0,0,0,1)',
		low: 'rgba(255,166,0,.8)',
		high: 'rgba(62,193,255,.8)',
		normal: {
			light: 'rgba(200,200,200,.1)',
			medium: 'rgba(200,200,200,.6)',
			heavy: 'rgba(200,200,200,.8)'
		}
	};

/* -- Add Missing elements -- */

	// Add an external asset, either a JS or CSS
	function addExternalAssets ( source, type = 'script' ) {

		// Create the element
		const element = document.createElement( type );

		if ( type === 'script' ) {
			element.src = source;
		}

		if ( type === 'link' ) {
			element.rel = 'stylesheet';
			element.href = source;
		}

		// Insert it on the page
		document.body.appendChild( element );
	}

	function addMapboxAPI() {

		// CSS
		addExternalAssets( api.css, 'link' );
		if ( api.cssSearch !== undefined ) {
			addExternalAssets( api.cssSearch, 'link' );
		}

		// Javascript
		addExternalAssets( api.js, 'script' );
		if ( api.jsSearch !== undefined ) {
			addExternalAssets( api.jsSearch, 'script' );
		}
	}

/* -- Custome control -- */

	function addToggle( race ) {

		// Create input and label
		const input = document.createElement( 'input' );
		const label = document.createElement( 'label' );

		// Add all the information for the input
		input.className = 'ss__toggle__input';
		input.id = 'ss__toggle__' + race;
		input.type = 'radio';
		input.name = 'ss__toggle';
		input.value = race;

		// Add all the information for the label
		label.className = 'ss__toggle__label';
		label.setAttribute( 'for', 'ss__toggle__' + race );
		label.innerHTML = race;

		// Add them to the interactive
		toggle.appendChild( input );
		toggle.appendChild( label );

		// Add interactivity to them
		input.onchange = function( event ) {
			showLayer( event.target.value );
		}
	}

/* -- Map -- */

	function setupMap() {
		// Give the API key
		mapboxgl.accessToken = api.accessToken;

		// Create the map
		map = new mapboxgl.Map({
			container: 'ss__mapbox',
			style: data.style,
			center: data.center,
			zoom: data.zoom
		});

		// disable map zoom when using scroll
		map.scrollZoom.disable();
	}

	function addControls() {
		// Add zoom and rotation controls
		map.addControl( new mapboxgl.NavigationControl(), 'bottom-right' );

		// Add Full screen control - BAD IDEA, doesn't work well with the offset on easeTo();
		// map.addControl( new mapboxgl.FullscreenControl() );

		// Add search address box
		map.addControl( new MapboxGeocoder( { accessToken: mapboxgl.accessToken } ), 'top-left' );

		// Add the control for race layers
		toggle = document.querySelector( '.ss__toggle' );
		racesLayer.forEach( race => addToggle( race ) );
	}

	function addTooltipLayer() {

		// Add the layer on the map
		map.addLayer({
			'id': 'tooltip',
			'type': 'circle',
			'source': 'schools',
			'source-layer': data.sourceLayer,
			'layout': {	'visibility': 'visible' },
			'paint': {
				'circle-opacity': 0,
				'circle-radius': [
					'curve', ['linear'], ['zoom'],
					1, 2, // Zoom 1 - 2px
					8, 4, // Zoom 8 - 4px
					12, 7, // Zoom 12 - 7px
					15, 20 // Zoom 15 - 20px
				]
			}
		});
	}

	function addRaceLayer( race ) {

		// add the layer into an array to keep track of them
		layers = layers || [];
		layers.push( race );

		// Add the layer on the map
		map.addLayer({
			'id': race,
			'type': 'circle',
			'source': 'schools',
			'source-layer': data.sourceLayer,
			'layout': {	'visibility': 'none' },
			'paint': {
				'circle-opacity': 1,
				'circle-radius': [
					'curve', ['linear'], ['zoom'],
					1, 2, // Zoom 1 - 2px
					8, 4, // Zoom 8 - 4px
					12, 7, // Zoom 12 - 7px
					15, 20 // Zoom 15 - 20px
				],

				// Make the colours changes based on states
				'circle-color': [
					'curve', ['linear'], ['zoom'],
					5, ['match',
								['get', 'outlier_' + race ],
								'L', colours.low,
								'N', colours.normal.light,
								'H', colours.high,
								'NA', colours.na,
								colours.normal.light
						 ],
					9, ['match',
								['get', 'outlier_' + race ],
								'L', colours.low,
								'N', colours.normal.medium,
								'H', colours.high,
								'NA', colours.na,
								colours.normal.medium
						 ],
					10, ['match',
								['get', 'outlier_' + race ],
								'L', colours.low,
								'N', colours.normal.heavy,
								'H', colours.high,
								'NA', colours.na,
								colours.normal.heavy
						 ]
				]
			}

		// Show those layers under the tooltip one
		}, data.tooltipUnderLayer );
	}

	function addDataToTheMap() {

		// Add the data to the map
		map.addSource( 'schools', {
			type: 'vector',
			url: data.tileset
		});

		// Add the layer for the tooltip
		addTooltipLayer();

		// Now let's add the Layer for each race by state
		racesLayer.forEach( race => addRaceLayer( race ) );
	}

	function showLayer( race ) {

		// Hide all the layers
		layers.map( layer => map.setLayoutProperty( layer, 'visibility', 'none' ) );

		// Show our specific layer
		// console.log( 'Show layer: ' + race );
		map.setLayoutProperty( race, 'visibility', 'visible' );

		// Change the class of the map to know which layer is visible
		map._container.className = 'mapboxgl-map';
		map._container.classList.add( race );
	}

/* -- Tooltip -- */

	function showTooltip( event ) {

			const data = event.features[0].properties;
			// console.clear();
			// console.table( data );

			// Center the map on the coordinates of the clicked element
			map.easeTo({
				center: event.lngLat,
				offset: [ 0, 150 ]
			});

			const tooltip = document.querySelector( '.ss__tooltip' ).cloneNode( true );

			// Name of the School
			tooltip.querySelector( '.ss__tooltip__name' ).innerHTML = data.name.toLowerCase();

			// Fill the table
			racesData.forEach( function( race ) {

				const percentage = '<span>%</span>';

				const school = data[ 'school_' + race ] + percentage;

				// We might be missing some data from Census
				const blocks = data[ 'blocks_' + race ] !== 'NA' ? data[ 'blocks_' + race ] + percentage : 'N/A';

				tooltip.querySelector( `.ss__tooltip__data__${ race }__school` ).innerHTML = school;
				tooltip.querySelector( `.ss__tooltip__data__${ race }__neighborhood` ).innerHTML = blocks;

				// Add a class to know the status of the outlier
				tooltip.querySelector( `.ss__tooltip__data__${ race }` ).classList.add( 'outlier-' + data[ 'outlier_' + race ] );
			});

			// Add the tooltip to the map
			new mapboxgl.Popup()
									.setLngLat( event.lngLat )
									.setHTML( tooltip.innerHTML )
									.addTo( map );
	}

/* -- Application -- */

	function app() {

		// Setup the Mapbox with all the information needed
		setupMap();

		// Wait until the map is ready
		map.on( 'load', function () {

			// to add the schools data to the map
			addDataToTheMap();

			// Then add the controls
			addControls();

			// Show our first layer
			showLayer( racesLayer[0] );
			document.querySelector( '.ss__toggle__input').setAttribute( 'checked', 'checked' );
		});

		// When a click event occurs on a feature in the states layer, open a popup at the
		// location of the click, with description HTML from its properties.
		map.on( 'click', 'tooltip', event => showTooltip( event ) );
	}

	// Start the whole thing when the DOM is complete
	document.addEventListener( 'readystatechange', function() {
		document.readyState === 'interactive' && addMapboxAPI();
		document.readyState === 'complete' && app();
	}, false );

// end of the interactive
})( document );
